const APP_SCHEME_URL = 'ourtour://app'
const OURTOUR_SCHEME_RE = /^ourtour:\/\//i

function safeDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export function buildAppSchemeUrl(url) {
  const rawUrl = typeof url === 'string' ? url.trim() : ''
  if (!rawUrl) return APP_SCHEME_URL

  if (OURTOUR_SCHEME_RE.test(rawUrl)) return rawUrl

  const decodedUrl = safeDecodeURIComponent(rawUrl)
  if (OURTOUR_SCHEME_RE.test(decodedUrl)) return decodedUrl

  return `${APP_SCHEME_URL}/h5?url=${encodeURIComponent(rawUrl)}`
}
